"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIDEBAR_ALIGNMENTS = exports.SIDEBAR_SIZES = exports.SIDEBAR_SIZES_CSS = void 0;
const SIDEBAR_SIZES_CSS = {
  "extra-small": "214px",
  small: "314px",
  "medium-small": "414px",
  medium: "514px",
  "medium-large": "614px",
  large: "714px",
  "extra-large": "814px"
};
exports.SIDEBAR_SIZES_CSS = SIDEBAR_SIZES_CSS;
const SIDEBAR_SIZES = ["extra-small", "small", "medium-small", "medium", "medium-large", "large", "extra-large"];
exports.SIDEBAR_SIZES = SIDEBAR_SIZES;
const SIDEBAR_ALIGNMENTS = ["left", "right"];
exports.SIDEBAR_ALIGNMENTS = SIDEBAR_ALIGNMENTS;